export default "__VITE_ASSET__808d9f00__"